import React from 'react';

import { Link, useLocation } from 'react-router-dom';

import styled from 'styled-components';

export default function FooterWithoutLang() {
  const location = useLocation().pathname;

  return (
    <StyledFooter>
      <StyledMobileFooterNavbar>
        <div>
          <StyledAboutBtn location={location}>
            <Link to="about">회사소개</Link>
          </StyledAboutBtn>
          <StyledTeamBtn location={location}>
            <Link to="team">팀</Link>
          </StyledTeamBtn>
          <StyledNewsBtn location={location}>
            <Link to="news">뉴스</Link>
          </StyledNewsBtn>
        </div>
      </StyledMobileFooterNavbar>
      <StyledContentsContainer>
        <StyledInformationContainer>
          <p>
            주식회사 인텔리퀀트 &nbsp; | &nbsp; 대표자명: 이종권 &nbsp; | &nbsp;
            주소: 서울특별시 금천구 가산디지털1로 212, 1405호(1109)
            (코오롱디지털타워애스턴)
            <br />
            사업자등록번호 717-81-00238
          </p>
          <p>
            주식회사 인텔리퀀트
            <br /> 대표자명: 이종권 <br />
            주소: 서울특별시 금천구 가산디지털1로 212, 1405호(1109)
            (코오롱디지털타워애스턴)
            <br />
            사업자등록번호 717-81-00238
          </p>
          <p>
            대표 번호: 070-5101-0724
            <br />
            <a href="mailto:info@intelliquant.net">
              <span>Email: info@intelliquant.net</span>
            </a>
          </p>

          <p>© IntelliQuant 2021. All rights reserved</p>
        </StyledInformationContainer>
        <StyledSnsIconContainer>
          <StyledLink
            href="https://blog.naver.com/intelliquant"
            target="_blank"
          >
            <StyledIcon
              alt="blog"
              src="images/components/footer/blog/group-16@3x.png"
            />
          </StyledLink>
          <StyledLink
            href="https://www.facebook.com/intelliquant/"
            target="_blank"
          >
            <StyledIcon
              alt="facebook icon"
              src="images/components/footer/facebook/group-29@3x.png"
            />
          </StyledLink>
          <StyledLink
            href="https://www.linkedin.com/company/intelliquant/about/"
            target="_blank"
          >
            <StyledIcon
              alt="linkedin icon"
              src="images/components/footer/linkedin/group-30@3x.png"
            />
          </StyledLink>
        </StyledSnsIconContainer>
      </StyledContentsContainer>
    </StyledFooter>
  );
}

const StyledFooter = styled.footer`
  padding: 80px 0;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.black};

  span,
  p {
    color: ${({ theme }) => theme.colors.grey2};
    font-size: ${({ theme }) => theme.pixelToRem(14)};
  }

  p {
    line-height: 2;
  }

  span {
    text-decoration: underline;
  }

  ${({ theme }) => theme.mobile`
    padding: 70px 32px;
  `}
`;

const StyledContentsContainer = styled.div`
  max-width: 1340px;
  margin: 0 auto;
  padding: 0 30px;
  ${({ theme }) => theme.flex('row', 'space-between', 'flex-start')}

  ${({ theme }) => theme.mobile`
    ${({ theme }) => theme.flex('row', 'space-between', 'flex-end')}
    padding: 0;
  `}
`;

const StyledInformationContainer = styled.div`
  p:first-child {
    margin-bottom: 20px;

    ${({ theme }) => theme.mobile`
      display: none;
    `}
  }

  p:nth-child(2) {
    display: none;
    margin-bottom: 32px;

    ${({ theme }) => theme.mobile`
      display: block;
    `}
  }

  p:nth-child(3) {
    margin-bottom: 20px;
  }

  p:last-child {
    font-weight: 300;
  }
`;

const StyledSnsIconContainer = styled.div`
  a:last-child {
    margin-right: 0;
  }

  ${({ theme }) => theme.mobile`
    ${({ theme }) => theme.flex('column')}

    a:last-child {
      margin-bottom: 0;
    }
  `}
`;

const StyledIcon = styled.img`
  width: 24px;
`;

const StyledLink = styled.a`
  margin-right: 32px;

  ${({ theme }) => theme.mobile`
    margin-right: 0;
    margin-bottom: 32px;
  `}
`;

const StyledMobileFooterNavbar = styled.div`
  display: none;
  margin-bottom: 32px;

  ${({ theme }) => theme.mobile`
    display: block;
  ${({ theme }) => theme.flex('row', 'space-between')};
  `}
`;

const StyledBtn = styled.button`
  margin-right: 32px;
  color: ${({ theme }) => theme.colors.grey3};
  font-size: ${({ theme }) => theme.pixelToRem(14)};
  text-decoration: underline;

  &:last-child {
    margin-right: 0;
  }
`;

const StyledAboutBtn = styled(StyledBtn)`
  a {
    color: ${({ theme, location }) => {
      if (location === '/about') return theme.colors.white;

      return theme.colors.grey3;
    }};
  }
`;

const StyledTeamBtn = styled(StyledBtn)`
  a {
    color: ${({ theme, location }) => {
      if (location === '/team') return theme.colors.white;

      return theme.colors.grey3;
    }};
  }
`;

const StyledNewsBtn = styled(StyledBtn)`
  a {
    color: ${({ theme, location }) => {
      if (location === '/news') return theme.colors.white;

      return theme.colors.grey3;
    }};
  }
`;
